let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8Dzgf")).then(() => parcelRequire('7K1UW'));